import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
export interface DataRequirements {
  checkBundle(code): Observable<any>;
  checkUserGrade(header): Observable<any>;
  wechatLogin(body): Observable<any>;
  appleLogin(body): Observable<any>;
  cleverLogin(body): Observable<any>;
  claimBundle(code): Observable<any>;
  getOTP(header): Observable<any>;
  verifyOTP(header): Observable<any>;
  checkUserInfo(header): Observable<any>;
  checkPlan(header): Observable<any>;
  updateUserDetail(header): Observable<any>;
  getCountryList(): Observable<any>;
  getStateList(code): Observable<any>;
  getCityList(cCode, sCode): Observable<any>;
  playerLogin(username, password): Observable<any>;
  globalLogin(username, password): Observable<any>;
}

export const DataRequirementsInjectionToken =
  new InjectionToken<DataRequirements>('home Data Requirements');
